// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__ALE3T","big":"default_big__iNMQX"};